import { faCircleNotch as faCircleNotchRegular } from "@fortawesome/pro-regular-svg-icons/faCircleNotch";
import { faHourglass } from "@fortawesome/pro-regular-svg-icons/faHourglass";
import { faArrowsRotate } from "@fortawesome/pro-solid-svg-icons";
import { faCircleNotch } from "@fortawesome/pro-solid-svg-icons/faCircleNotch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { resolveMprcRadiusSize } from "components/styles/resolvers";
import usePrevious from "hooks/usePrevious";
import * as React from "react";

////////////////////////////////////////////////////////////////////////////////////

export type MprcRequestIndicatorType = "post" | "request" | "waiting" | "suspense" | "downloading";

interface IProps {
    type?: MprcRequestIndicatorType;
    visible?: boolean;
    roundedBackdrop?: boolean;
    backdrop?: boolean;
    message?: React.ReactNode;
    restoreFocus?: boolean;
}

export const MprcRequestIndicator: React.FC<IProps> = (props) => {
    const el = React.useRef<HTMLInputElement | null>(null);
    const { message, visible, type = "request", roundedBackdrop = false, backdrop = true, restoreFocus = true } = props;
    const prevVisible = usePrevious(visible);

    const leaveFocus = () => {
        if (document.activeElement?.tagName == "INPUT") {
            el.current = (document.activeElement as HTMLInputElement);
            el.current.blur();
        }
    };

    const returnFocus = () => {
        if (el.current) el.current.focus();
    };

    React.useEffect(() => {
        return function cleanUp() {
            returnFocus();
        };
    }, []);

    React.useEffect(() => {
        if (!restoreFocus) return;
        if (prevVisible != props.visible) {
            if (props.visible) {
                leaveFocus();
            }
            else {
                returnFocus();
            }
        }
    }, [props.visible]);


    return visible === false
        ? null
        : (
            <Box
                style={
                    {
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        margin: 0,
                        padding: 0,
                        zIndex: 9998,
                        position: "fixed",
                        background: backdrop ? "rgba(0, 0, 0, 0.2)" : undefined,
                        borderRadius: backdrop && roundedBackdrop ? resolveMprcRadiusSize("sm") : "inherit",
                    }
                }>
                <Box
                    style={
                        {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                            zIndex: 9999,
                        }
                    }
                >
                    <Box
                        sx={(theme) =>
                        ({
                            minWidth: "192px",
                            borderRadius: message ? 2 : undefined,
                            background: message ? theme.palette.common.white : undefined,
                            padding: message ? 2 : undefined,
                            border: message ? "solid 1px #a0a0a0" : undefined,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            color: type == "request" || type == "suspense" || "downloading"
                                ? theme.palette.primary.main
                                : theme.palette.warning.main

                        })
                        }
                    >
                        {
                            type == "suspense"
                                ? <Box sx={{ position: "relative", textAlign: "center" }}>
                                    <img src="img/app/app-logo.png" style={{ width: "96px" }} />
                                    <Box sx={{ position: "absolute", top: "-1px", left: "28px" }}>
                                        <FontAwesomeIcon
                                            icon={faCircleNotchRegular}
                                            fontSize="108px"
                                            fixedWidth
                                            spin
                                        />
                                    </Box>
                                </Box>
                                : <FontAwesomeIcon
                                    size="3x"
                                    fixedWidth
                                    spin
                                    icon={
                                        type == "post" || type == "request"
                                            ? faCircleNotch
                                            : type == "waiting"
                                                ? faHourglass
                                                : faArrowsRotate
                                    }
                                />
                        }
                        {
                            message ? <p>{message}</p> : null
                        }
                    </Box>
                </Box>
            </Box >
        );
};
